
import useBlProviders from '@/composables/providers/useBlProvider'
import { useUserStore } from '@/stores/userStore'
import { storeToRefs } from 'pinia'

/**
 * @deprecated don`t use this!
 */
export async function makeGetCacheDataByNameWithUpdatableVersions() {
  const { getCurrentVersions } = useBlProviders()

  const { selectedCompanyId } = storeToRefs(useUserStore())
  let versions = null

  return {
    getCacheDataByName: function (name) {
      return [
        `${name}--${selectedCompanyId.value}`,
        versions[`${name}--${selectedCompanyId.value}`],
      ]
    },
    updateVersions: async function () {
      versions = await getCurrentVersions(selectedCompanyId.value)
    }
  };
}

/**
 * @deprecated don`t use this!
 */
async function makeGetCacheDataByName() {
  const { getCurrentVersions } = useBlProviders()

  const { selectedCompanyId } = storeToRefs(useUserStore())
  let versions = await getCurrentVersions(selectedCompanyId.value)

  async function updateVersions() {
    versions = await getCurrentVersions(selectedCompanyId.value)
  };

  function getCacheDataByName(name) {

    return [
      `${name}--${selectedCompanyId.value}`,
      versions[`${name}--${selectedCompanyId.value}`],
    ]
  };

  getCacheDataByName.updateVersions = updateVersions;

  return getCacheDataByName
}



export default makeGetCacheDataByName
